import {
    Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Stack,
    Typography,
} from "@mui/material";
import {Add} from "@mui/icons-material";
import React from "react";
import CarouselCard from "./carousel/CarouselCard";

export default function CarouselSection(
    {
        templateType,
        headerMediaType,
        setHeaderMediaType,
        numButtons,
        setNumButtons,
        buttonTypes,
        handleButtonTypeChange,
        carouselCards,
        handleRemoveCard,
        handleFileUpload,
        handleCardChange,
        addVariableToCard,
        handleAddCard,
        DynamicButtonFields,
    }
) {
    if (templateType !== "carousel") return null; // ✅ Evita devolver JSX innecesario

    return (
        <Paper variant="outlined" sx={{p: 2, borderRadius: 3}}>
            <Stack gap={2}>
                <Typography variant="h6">Carousel*</Typography>
                <Typography variant="body2" color="text.secondary">
                    Add media, buttons and card descriptions for your carousel cards
                </Typography>

                {/* ─── CONFIGURACIÓN GLOBAL DEL CARRUSEL ─────────────────────────────── */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {xs: "1fr", sm: "1fr 1fr 1fr"},
                        gap: 2,
                    }}
                >
                    <FormControl fullWidth>
                        <InputLabel id="header-media-type">Header media type</InputLabel>
                        <Select
                            labelId="header-media-type"
                            label="Header media type"
                            value={headerMediaType || ""}
                            onChange={(e) => setHeaderMediaType(e.target.value)}
                            MenuProps={{
                                disablePortal: true, // ✅ corrige comportamiento en modales o popovers
                            }}
                        >
                            <MenuItem value="image">Image</MenuItem>
                            <MenuItem value="video">Video</MenuItem>
                        </Select>
                    </FormControl>


                    <FormControl fullWidth>
                        <InputLabel id="num-buttons">No of buttons</InputLabel>
                        <Select
                            labelId="num-buttons"
                            label="No of buttons"
                            value={numButtons}
                            onChange={(e) => setNumButtons(Number(e.target.value))}
                        >
                            {[1, 2].map((n) => (
                                <MenuItem key={n} value={n}>
                                    {n}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                {/* Tipos de botón globales */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns:
                            numButtons === 1
                                ? "1fr"
                                : numButtons === 2
                                    ? "1fr 1fr"
                                    : "1fr 1fr 1fr",
                        gap: 2,
                    }}
                >
                    {Array.from({length: numButtons}).map((_, i) => (
                        <FormControl key={i} fullWidth>
                            <InputLabel id={`button-type-${i + 1}`}>
                                Button type {i + 1}
                            </InputLabel>
                            <Select
                                labelId={`button-type-${i + 1}`}
                                label={`Button type ${i + 1}`}
                                value={buttonTypes[i] || "quick_reply"}
                                onChange={(e) => handleButtonTypeChange(i, e.target.value)}
                            >
                                <MenuItem value="quick_reply">Quick Reply</MenuItem>
                                <MenuItem value="url">URL</MenuItem>
                                <MenuItem value="phone">Phone Number</MenuItem>
                            </Select>
                        </FormControl>
                    ))}
                </Box>

                {/* ─── CARDS ────────────────────────────────────────────────────────── */}
                {carouselCards.map((card) => (
                    <CarouselCard
                        key={card.id} // ✅ importante
                        card={card}
                        headerMediaType={headerMediaType}
                        buttonTypes={buttonTypes}
                        numButtons={numButtons}
                        handleRemoveCard={handleRemoveCard}
                        handleFileUpload={handleFileUpload}
                        handleCardChange={handleCardChange}
                        addVariableToCard={addVariableToCard}
                        DynamicButtonFields={DynamicButtonFields}
                    />
                ))}

                {/* Add another card */}
                <Button
                    startIcon={<Add/>}
                    variant="outlined"
                    onClick={handleAddCard}
                    sx={{alignSelf: "flex-start"}}
                >
                    Add another card
                </Button>
            </Stack>
        </Paper>
    );
}
